import { render, staticRenderFns } from "./BusinessConfigForm.vue?vue&type=template&id=29e5dcf6&scoped=true&"
import script from "./BusinessConfigForm.vue?vue&type=script&lang=js&"
export * from "./BusinessConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e5dcf6",
  null
  
)

export default component.exports